import { BankConnectionList } from "Components/Shared/BankConnectionList";
import { FullHeightForm } from "Components/Shared/FormStyles";
import { useBankingAuth } from "Hooks/useBankingAuth";
import type { BankEnvironment } from "Infrastructure/Api/Api";

type Props = {
  onNextStepRequested: () => void;
};

export const BankAccountStep = ({ onNextStepRequested: _unused }: Props) => {
  const { isPending, authorize, selectedEnvironment } = useBankingAuth();

  const onBankSelected = (environment: BankEnvironment) => {
    if (!isPending) {
      authorize({ environment });
    }
  };

  return (
    <FullHeightForm>
      <BankConnectionList
        isPending={isPending}
        onBankSelected={onBankSelected}
        selectedEnvironment={selectedEnvironment}
      />
    </FullHeightForm>
  );
};
